import {
  Button,
  CircularProgress,
  Snackbar,
  TextField,
} from "@material-ui/core";
import { Field, Form, Formik } from "formik";
import UserPlaceholder from "images/user.png";
import React, { useState } from "react";
import * as Yup from "yup";
import useApi from "../../../../hooks/api";
import useAuth from "../../../../hooks/auth";
import Alert from "../../../ui/alert";

const CustomField = ({ field, form, ...props }) => (
  <TextField {...props} {...field} fullWidth />
);

const EditForm = ({ user }) => {
  const { put } = useApi();
  const { setAuth } = useAuth();
  const [profileUpdated, setProfileUpdated] = useState(false);

  const SignupSchema = Yup.object().shape({
    name: Yup.string().required("Nome não pode ficar vazio!"),
  });

  const handleSubmit = (values, actions) => {
    actions.setSubmitting(true);

    put(`/users/${user.id}`, values)
      .then((response) => {
        setProfileUpdated(true);
        setAuth(response);
        actions.setSubmitting(false);
      })
      .catch(() => {
        alert(
          "Não conseguimos processar sua solicitação. Tente novamente mais tarde!"
        );

        actions.setSubmitting(false);
      });
  };

  return (
    <Formik
      initialValues={{
        name: user.name,
        nickname: user.nickname || "",
      }}
      validationSchema={SignupSchema}
      onSubmit={handleSubmit}
    >
      {({ errors, touched, isSubmitting, dirty }) => (
        <Form>
          <div className="mp-left">
            <div className="mp-image">
              <img src={UserPlaceholder} />
              <i className="fa fa-user hide"></i>
            </div>

            <div className="m-b-10">
              {/* <a href="#" className="btn btn-info btn-block btn-sm" disabled={true}>
              Alterar imagem
            </a> */}
            </div>
          </div>

          <div className="mp-right">
            <fieldset>
              <div className="row">
                <div className="form-group col-md-6">
                  <Field
                    name="name"
                    type="text"
                    label="Nome"
                    component={CustomField}
                  />
                  {errors.name && touched.name ? (
                    <div className="mp-color-error">{errors.name}</div>
                  ) : null}
                </div>
              </div>
              <div className="row pb-10">
                <div className="form-group col-md-6">
                  <Field
                    name="nickname"
                    type="text"
                    label="Apelido"
                    component={CustomField}
                  />
                  {errors.nickname && touched.nickname ? (
                    <div className="mp-color-error">{errors.nickname}</div>
                  ) : null}
                </div>
              </div>

              <div className="row">
                <div className="form-group col-md-6 m-t-20">
                  <Button
                    fullWidth
                    disabled={!dirty || isSubmitting}
                    className="btn btn-primary btn-mercatorio"
                    type="submit"
                  >
                    {isSubmitting ? (
                      <CircularProgress
                        size={24}
                        style={{ marginBottom: "0px", color: "white" }}
                      />
                    ) : (
                      <span>ATUALIZAR</span>
                    )}
                  </Button>
                </div>
              </div>
            </fieldset>
          </div>

          <Snackbar
            open={profileUpdated}
            autoHideDuration={3000}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            onClose={() => setProfileUpdated(false)}
          >
            <Alert message="Perfil atualizado com sucesso!" />
          </Snackbar>
        </Form>
      )}
    </Formik>
  );
};

export default EditForm;
